module.exports = __webpack_public_path__ + "img/dropdown-arrow.6614ccb0.svg";